import { OperationalUpdateAreaDTO } from '../models/ListAreas'
import { TicketRepository } from '../repositories/TicketRepository'

export function OperationalUpdateAreaCase(ticketRepository: TicketRepository) {
  return async function ({
    areaId,
    data
  }: {
    areaId: string
    data: OperationalUpdateAreaDTO
  }) {
    return await ticketRepository.operationalUpdateArea({ areaId, data })
  }
}
